import { Inject, Injectable } from "@angular/core";
import { ProgressDialogHandle, ProgressDialogServiceBase } from "@ankaadia/ankaadia-shared-frontend";
import { TranslocoService } from "@jsverse/transloco";
import { DialogService as OldDialogService, DynamicDialogRef as OldDynamicDialogRef } from "primeng-v17/dynamicdialog";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { NewUiProgressDialogComponent } from "../components/progress-dialog/new-ui-progress-dialog.component";
import { ProgressDialogComponent } from "../components/progress-dialog/progress-dialog.component";

@Injectable({ providedIn: "root" })
export class ProgressDialogService extends ProgressDialogServiceBase {
  static override instance: ProgressDialogService;

  private dialogRef: OldDynamicDialogRef | DynamicDialogRef | null = null;
  private cancelledSubject: Subject<void> | null = null;

  constructor(
    @Inject(environment.newUI ? DialogService : OldDialogService)
    private readonly dialogService: OldDialogService | DialogService,
    private readonly transloco: TranslocoService
  ) {
    super();
    ProgressDialogService.instance = this;
    ProgressDialogServiceBase.instance = this;
  }

  open(title: string, progressId: string, cancelable = true): ProgressDialogHandle {
    this.close();

    this.cancelledSubject = new Subject<void>();
    const translatedTitle = this.transloco.translate(title);

    if (environment.newUI) {
      this.dialogRef = (<DialogService>this.dialogService).open(NewUiProgressDialogComponent, {
        header: translatedTitle,
        data: { progressId, cancelable },
        closable: false,
        focusOnShow: false,
        modal: true,
        appendTo: "body",
      });
    } else {
      this.dialogRef = (<OldDialogService>this.dialogService).open(ProgressDialogComponent, {
        width: "30rem",
        header: translatedTitle,
        closable: false,
        data: { progressId, cancelable },
      });
    }

    this.dialogRef?.onClose?.subscribe(() => {
      this.cancelledSubject?.next();
      this.cancelledSubject?.complete();
      this.cancelledSubject = null;
      this.dialogRef = null;
    });

    return {
      cancelled$: this.cancelledSubject.asObservable(),
    };
  }

  close(): void {
    if (this.dialogRef) {
      const ref = this.dialogRef;
      this.dialogRef = null;
      this.cancelledSubject = null;
      ref.close();
    } else {
      // If dialogRef is null (e.g. open() returned null due to duplication check),
      // still clean up the cancelledSubject to avoid Subject leaks.
      this.cancelledSubject?.complete();
      this.cancelledSubject = null;
    }
  }
}
